<template>
  <div>
    <van-image
      class="img"
      v-for="(item, index) in imageList"
      :key="index"
      lazy-load
      :src="item"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="30" />
      </template>
    </van-image>
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload, Loading } from "vant";
import { Image as VanImage } from "vant";
Vue.use(Lazyload);
Vue.use(VanImage);
Vue.use(Loading);
export default {
  created() {
    // 解析查询参数
    this.getQury();
    this.setViewport();
  },
  data() {
    return {
      queryMsg: {},
      imageList: [],
      loading: false,
      finished: false,
    };
  },
  methods: {
    getQury() {
      this.queryMsg = this.$route.query;
      if (this.queryMsg.type) {
        this.getData();
      }
      if (this.queryMsg.title) {
        document.title = this.queryMsg.title;
      }
    },
    getData() {
      // 个人信息报告
      if (this.queryMsg.type == "hpmraAboutUs") {
        for (let i = 1; i <= 13; i++) {
          this.imageList.push(
            "https://static.xchengtech.cn/绩效会研究会宣传册 (" + i + ").jpg"
          );
        }
      }
    },
    setViewport() {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute(
          "content",
          "width=device-width, initial-scale=1.0, maximum-scale=3.0, user-scalable=yes"
        );
      } else {
        viewport = document.createElement("meta");
        viewport.setAttribute("name", "viewport");
        viewport.setAttribute(
          "content",
          "width=device-width, initial-scale=1.0, maximum-scale=3.0, user-scalable=yes"
        );
        document.head.appendChild(viewport);
      }
    },
  },
};
</script>
<style scoped>
.img {
  display: block;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/view/previewImage/index.vue